import React from 'react'
import styled from '@emotion/styled'
import Masonry from 'react-masonry-component';

const masonryOptions = {
  transitionDuration: 0.5
};

const CardList = props => {
  return (
    <Masonry
      className={'card-list'} // default ''
      elementType={'div'} // default 'div'
      options={masonryOptions} // default {}
    >
      {props.children}
    </Masonry>
  )
}

export default CardList